import { Navigate, Outlet, Route, Routes, useMatch } from 'react-router-dom';

import { MessageTemplateEdit } from './components/EditMessageTemplate';
import { MessageTemplateList } from './components/List';
import { MessageTemplateNavbar } from './components/Navbar';
import { MessageTemplateNew } from './components/NewMessageTemplate';

import { MessageTemplates as MessageTemplatesLayout } from './';

const Layout = (): JSX.Element => {
    // Navbar only renders on the list route, matching the v5 behavior
    const isListRoute = useMatch('/templates/list');

    return (
        <>
            {isListRoute && <MessageTemplateNavbar />}
            <MessageTemplatesLayout>
                <Outlet />
            </MessageTemplatesLayout>
        </>
    );
};

export const MessageTemplateRoutes = (): JSX.Element => (
    <Routes>
        <Route element={<Layout />}>
            <Route path="list" element={<MessageTemplateList />} />
            <Route path="new" element={<MessageTemplateNew />} />
            <Route path="edit/:messageTemplateId" element={<MessageTemplateEdit />} />
            <Route path="*" element={<Navigate to="/templates/list" replace />} />
        </Route>
    </Routes>
);
